export default __webpack_public_path__ + "f1147ab8f65fd96d7d4e484a81b54245.png";